import React, { useRef, useEffect } from 'react';
import { Send, ImageIcon } from 'lucide-react';
import {API_IMAGE_URL2} from '../../lib/api';

export default function ChatBox({
  selectedEmployee,
  messages,
  newMessage,
  setNewMessage,
  imageFile,
  setImageFile,
  onSendMessage,
  currentUser,
  onDeleteMessage,
}) {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  if (!selectedEmployee) {
    return (
      <div className="flex-1 flex items-center justify-center text-gray-500">
        Select an employee to chat
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col w-full max-w-full md:max-w-[500px] mx-auto">
      {/* Header */}
      <div className="border-b p-3 font-semibold bg-gray-50">
        {selectedEmployee.full_name}
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-100">
        {messages.length === 0 && (
          <p className="text-gray-400 italic text-center mt-10">No messages yet</p>
        )}

        {messages.map((msg) => {
          const isSentByCurrentUser = msg.sender_id === currentUser.id;
          return (
            <div
              key={msg.id}
              className={`flex ${isSentByCurrentUser ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`relative p-2 rounded shadow max-w-xs ${
                  isSentByCurrentUser ? 'bg-blue-500 text-white' : 'bg-white text-gray-800'
                }`}
              >
                {msg.message && <p>{msg.message}</p>}
                {msg.image_url && (
                  
                  <img
                    src={`${API_IMAGE_URL2}${msg.image_url.startsWith('/') ? msg.image_url.slice(1) : msg.image_url}`}
                    alt="chat"
                    className="max-w-full rounded mt-1"
                  />
                )}
                <small
                  className={`block text-xs mt-1 text-right ${
                    isSentByCurrentUser ? 'text-blue-100' : 'text-gray-400'
                  }`}
                >
                  {new Date(msg.sent_at).toLocaleTimeString()}
                </small>

                {/* Delete button */}
                {isSentByCurrentUser && (
                  <button
                    onClick={() => onDeleteMessage(msg.id)}
                    className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 text-white rounded-full w-5 h-5 text-xs flex items-center justify-center"
                    title="Delete"
                  >
                    ×
                  </button>
                )}
              </div>
            </div>
          );
        })}

        <div ref={messagesEndRef} />
      </div>

      {/* Input Form */}
      <form
        onSubmit={onSendMessage}
        className="flex items-center gap-2 p-3 border-t bg-white"
      >
        <input
          type="text"
          placeholder="Type a message..."
          className="w-[130px] md:w-[200px] border rounded px-2 py-1 text-sm focus:outline-none"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImageFile(e.target.files[0])}
          className="hidden"
          id="chat-image-upload"
        />

        <label
          htmlFor="chat-image-upload"
          className="cursor-pointer bg-gray-200 px-2 py-1 flex items-center justify-center rounded hover:bg-gray-300"
          title="Upload Image"
        >
          <ImageIcon size={18} />
        </label>

        <button
          type="submit"
          className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
        >
          <Send size={18} />
        </button>
      </form>
    </div>
  );
}
